import firebase from 'firebase/compat/app'
import 'firebase/compat/firestore'
import 'firebase/compat/auth'
import 'firebase/compat/functions'
import 'firebase/functions'
import 'firebase/analytics'
import 'firebase/compat/storage'
import { getAuth } from 'firebase/auth'

//v9
import { initializeApp } from 'firebase/app'
import { getFirestore } from 'firebase/firestore'
import { getFunctions } from 'firebase/functions'

const prodConfig = {
  apiKey: 'AIzaSyDkutrLTa07638OC79xujGC-4S6rUvfHak',
  authDomain: 'hyve-cardiff.firebaseapp.com',
  projectId: 'hyve-cardiff',
  storageBucket: 'hyve-cardiff.firebasestorage.app',
  messagingSenderId: '196432294306',
  appId: '1:196432294306:web:b327375bc2d528cdf782fb',
}

const devConfig = {
  apiKey: 'AIzaSyDkutrLTa07638OC79xujGC-4S6rUvfHak',
  authDomain: 'hyve-cardiff.firebaseapp.com',
  projectId: 'hyve-cardiff',
  storageBucket: 'hyve-cardiff.firebasestorage.app',
  messagingSenderId: '196432294306',
  appId: '1:196432294306:web:b327375bc2d528cdf782fb',
}

const firebaseApp = initializeApp(
  process.env.NODE_ENV === 'development' ? devConfig : prodConfig,
)

firebase.initializeApp(
  process.env.NODE_ENV === 'development' ? devConfig : prodConfig,
)

export const createUserProfileDocument = async (userAuth, additionalData) => {
  if (!userAuth) return

  const userRef = await firestore.doc(`users/${userAuth.uid}`)
  const snapshot = await userRef.get()

  if (!snapshot.exists) {
    const { email } = userAuth
    const createdAt = new Date()

    try {
      userRef.set({ email, createdAt, ...additionalData, credits: 0 })
    } catch (error) {
      console.log('error creating user', error.message)
    }
  }
  return userRef
}

/**
 * Sends user to the Stripe hosted payment page for a subscription.
 * @param {string} API - Stripe price key
 * @param {string} user - Firebase Auth UID
 * @param {string} [cycle] - Billing cycle. Weekly memberships get no free trial.
 */
export const sendToCheckout = async (API, user, cycle) => {
  const docRef = await firestore
    .collection('users')
    .doc(user)
    .collection('checkout_sessions')
    .add({
      mode: 'subscription',
      price: `${API}`,
      allow_promotion_codes: true,
      ...(cycle !== 'Weekly' && { trial_period_days: 1 }),
      setup_future_usage: 'off_session',
      success_url: 'https://www.trainhyve.com/thanks',
      cancel_url: window.location.origin,
    })
  // Wait for the CheckoutSession to get attached by the extension

  docRef.onSnapshot((snap) => {
    const { error, url } = snap.data()
    if (error) {
      // Show an error to your customer and
      // inspect your Cloud Function logs in the Firebase console.
      alert(`An error occured: ${error.message}`)
    }
    if (url) {
      // We have a Stripe Checkout URL, let's redirect.
      window.location.assign(url)
    }
  })
}

// Sends user to the Strip hosted payment page
// API - Stripe price key
// user - Firebase Auth UID
export const sendToSingleCheckout = async (API, user) => {
  const docRef = await firestore
    .collection('users')
    .doc(user)
    .collection('checkout_sessions')
    .add({
      mode: 'payment',
      price: `${API}`,
      allow_promotion_codes: true,
      success_url: window.location.origin,
      cancel_url: window.location.origin,
    })
  // Wait for the CheckoutSession to get attached by the extension

  docRef.onSnapshot((snap) => {
    const { error, url } = snap.data()
    if (error) {
      // Show an error to your customer and
      // inspect your Cloud Function logs in the Firebase console.
      alert(`An error occured: ${error.message}`)
    }
    if (url) {
      // We have a Stripe Checkout URL, let's redirect.
      window.location.assign(url)
    }
  })
}

export const auth = firebase.auth()
export const newAuth = getAuth(firebaseApp)
export const firestore = firebase.firestore()
export const newFirestore = getFirestore(firebaseApp)
export const storage = firebase.storage()
export const functions = getFunctions(firebaseApp, 'europe-west2')

export const portalRedirect = async () => {
  const functionRef = firebase
    .app()
    .functions('europe-west2')
    .httpsCallable('ext-firestore-stripe-payments-createPortalLink')
  const { data } = await functionRef({ returnUrl: window.location.origin })
  window.location.assign(data.url)
}

/**
 * Enrols a visitor into the HYVE Cardiff newsletter segment in Resend and
 * triggers a welcome email via the addNewsletterContact callable function.
 *
 * @param {{email: string, firstName: string}} params subscriber details
 * @returns {Promise<{success: boolean}>}
 */
export const subscribeToNewsletter = async ({ email, firstName }) => {
  const functionRef = firebase
    .app()
    .functions('europe-west2')
    .httpsCallable('addNewsletterContact')
  const { data } = await functionRef({ email, firstName })
  return data
}

/**
 * Admin-only: change a member's email across Auth, Firestore, and Stripe.
 * @param {{uid: string, newEmail: string}} params target user id and new email
 * @returns {Promise<{success: boolean, email: string, stripeSynced: boolean}>}
 */
export const changeUserEmail = async ({ uid, newEmail }) => {
  const functionRef = firebase
    .app()
    .functions('europe-west2')
    .httpsCallable('changeUserEmail')
  const { data } = await functionRef({ uid, newEmail })
  return data
}

export const resetPassword = (email) => {
  firebase
    .auth()
    .sendPasswordResetEmail(email)
    .then(() => {
      console.log(' Password reset email sent!')
    })
    .catch((error) => {
      var errorMessage = error.message
      console.log(errorMessage)
    })
}

export default firebase
